import "./index.scss"
import React from "react"
import { Box, BoxProps } from "@mui/material"
import classNames from "classnames"
import GradientWrapper from "../GradientWrapper"

const colorSet = ["black", "black50", "darkest-gray", "darker-gray"] as const

interface Props extends BoxProps {
  variant: typeof colorSet[number]
  p?: BoxProps["p"]
  withGradient?: boolean
  borderRadius?: string
}

const CustomCard = ({
  variant,
  withGradient,
  className,
  borderRadius,
  children,
  p,
  ...props
}: Props) => {
  const mergedClassNames = classNames(
    className,
    "component-custom-card",
    variant,
  )

  if (withGradient) {
    return (
      <GradientWrapper
        className={mergedClassNames}
        borderRadius={borderRadius ?? "10px"}
        {...props}
      >
        <Box p={p ?? 3}>{children}</Box>
      </GradientWrapper>
    )
  }

  return (
    <Box
      p={p ?? 3}
      className={mergedClassNames}
      borderRadius={borderRadius ?? "10px"}
      {...props}
    >
      {children}
    </Box>
  )
}

export default CustomCard
